/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    small: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'a',
    small: false,
};

const Loader = (props) => {
    const classNames = [
        's-loader',
        props.small ? 's-loader_size_small' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <div className="s-loader__round" />
            <div className="s-loader__border" />
        </props.componentClass>
    );
};

Loader.propTypes = propTypes;

Loader.defaultProps = defaultProps;

export default Loader;
